import { WORKFLOW_STEPS } from '@/mocks/technical';
import { SectionHeading } from './ui';

export default function WorkflowSection() {
  return (
    <section className="rounded-3xl border border-slate-200/80 bg-white p-6 md:p-8">
      <SectionHeading
        eyebrow="Quy trình"
        title="Quy trình phân tích kỹ thuật"
        subtitle="Từ dữ liệu giá đến đánh giá kết quả trong một chuỗi logic thống nhất."
      />

      <div className="mt-8 grid grid-cols-1 gap-0 md:grid-cols-3">
        {WORKFLOW_STEPS.map((step, i) => (
          <div key={step.num} className="relative flex md:block">
            {/* Connector line (desktop) */}
            {i < WORKFLOW_STEPS.length - 1 && (
              <div className="absolute left-5 top-12 hidden h-px w-full bg-gradient-to-r from-violet-200 to-transparent md:block" />
            )}
            {/* Vertical connector (mobile) */}
            {i < WORKFLOW_STEPS.length - 1 && (
              <div className="absolute left-5 top-12 h-full w-px bg-gradient-to-b from-violet-200 to-transparent md:hidden" />
            )}
            <div className="relative flex-1 pr-6 pb-8 md:pr-8">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-slate-900 font-mono text-xs font-bold text-white">
                {step.num}
              </span>
              <h4 className="mt-4 font-display text-base font-bold text-slate-900">{step.title}</h4>
              <p className="mt-1 text-xs leading-relaxed text-slate-500">{step.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}